// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tu-2";
export var chatLink = "_tu-0";
export var chatText = "_tu-1";